import * as z from 'zod';

import type { CreateSchemaTypes } from '../createZodSchema';

export function addressValidator(field: CreateSchemaTypes) {
  const baseValidators = {
    [field.nameZipCode]: z.string().regex(/^[A-Za-z0-9\s-]{3,10}$/, 'Invalid postal code format'),
    [field.nameStreetNumber]: z
      .string()
      .regex(/^[A-Za-z0-9\s-]+$/, 'Invalid street number')
      .max(10, 'Street number too long'),
    [field.nameStreet]: z.string(),
    [field.nameCity]: z.string(),
    [field.nameBoxNumber]: z.string().optional().nullable(),
  };

  if (field.required) {
    return Object.fromEntries(
      Object.entries(baseValidators).map(([key, validator]) => [
        key,
        // key === field.nameBoxNumber ? validator : validator.min(1, 'This field is required'),
        key === field.nameBoxNumber ? validator : validator,
      ]),
    );
  }

  return baseValidators;
}
